import {CurrentRepositoryProvider} from '@github-ui/current-repository'
import {useRoutePayload} from '@github-ui/react-core/use-route-payload'
import type React from 'react'
import {useState} from 'react'
import type {CommitsPayload} from './types/commits-types'

/**
 * The App component is used to render content which should be present on _all_ routes within this app
 */
export function App(props: {children?: React.ReactNode}) {
  const payload = useRoutePayload<CommitsPayload>()
  const [repo] = useState(payload?.repo)

  return <CurrentRepositoryProvider repository={repo}>{props.children}</CurrentRepositoryProvider>
}

try{ App.displayName ||= 'App' } catch {}